export default "__VITE_ASSET__2fdfcd81__"